import { ResumeTopFoldIcon } from '@room-match/shared-ui-components';
import ProgressBar from 'shared/components/ProfileProgressBar/ProgressBar';
import { useTheme } from '@material-ui/core';
import { useState } from 'react';
import {
  CompletionCont,
  CompletionText,
  Credits,
  HLeft,
  HRight,
  MainCont,
  ResumeContentCont,
  ResumeHeader,
  ResumeTitle,
  TextsCont,
} from './Resume.styles';
import ResumeContent from './ResumeContent';
import { COLORS } from 'shared/constants/COLORS';
const {
  ERROR_TEXT,
  WARNING_CIRCULAR_PROGRESS_BAR,
  ERROR_CIRCULAR_PROGRESS_BAR,
  WARNING_TEXT,
  DARK_CIRCULAR_PROGRESS_BAR_BACKGROUND,
  GRAY_CIRCULAR_PROGRESS_BACKGROUND,
} = COLORS;

type ResumeProps = {
  permissions: string[];
};

function Resume({ permissions }: ResumeProps) {
  const [credits, setcredits] = useState(0);
  const theme = useTheme();
  const completeness = () => {
    switch (credits) {
      case 0:
        return 0;
      default:
        return 100;
    }
  };
  return (
    <MainCont>
      <ResumeHeader>
        <HRight>
          <ResumeTopFoldIcon style={{ width: 30, height: 40 }} />
          <TextsCont>
            <ResumeTitle>Resume</ResumeTitle>
            <Credits>{credits} Credits</Credits>
          </TextsCont>
        </HRight>

        <HLeft>
          <CompletionCont>
            <CompletionText
              style={{
                color: `${completeness() === 100 ? WARNING_TEXT : completeness() > 50 ? WARNING_TEXT : ERROR_TEXT}`,
              }}
            >
              {completeness()}% Complete
            </CompletionText>
            <ProgressBar
              borderRadius={8}
              percent={completeness()}
              completeColor={`${completeness() === 100 ? WARNING_CIRCULAR_PROGRESS_BAR : completeness() > 50 ? WARNING_CIRCULAR_PROGRESS_BAR : ERROR_CIRCULAR_PROGRESS_BAR}`}
              backgroundColor={
                theme.palette.type === 'dark'
                  ? DARK_CIRCULAR_PROGRESS_BAR_BACKGROUND
                  : GRAY_CIRCULAR_PROGRESS_BACKGROUND
              }
            />
          </CompletionCont>
        </HLeft>
      </ResumeHeader>

      <ResumeContentCont>
        <ResumeContent setCredits={(count: number) => setcredits(count)} permissions={permissions} />
      </ResumeContentCont>
    </MainCont>
  );
}

export default Resume;
